import Swal from 'sweetalert2'
import axios from 'axios'
import { on } from 'delegated-events'

export default class CartPanel {
    constructor() {
        this.bindEvents()
    }

    bindEvents() {
        on('click', '.remove-cart-panel-item', this.removeItemFromCart.bind(this))
        on('click', '.cart-panel-item-bottom .product-quantity .add', this.handleQuantity.bind(this))
        on('click', '.cart-panel-item-bottom .product-quantity .subtract', this.handleQuantity.bind(this))
    }

    handleQuantity(event) {
        const id = event.target.getAttribute('data-id')
        const parent = event.target.parentNode
        const quantity = parent.querySelector('.quantity')
        let type = null

        if (event.target.classList.contains('add')) {
            type = 'add'
            quantity.value = quantity.value < quantity.max ? quantity.valueAsNumber + 1 : quantity.value
        } else {
            type = 'subtract'
            quantity.value = quantity.value == 0 ? 0 : quantity.valueAsNumber - 1
        }

        axios
            .post('/cart/change.js', {
                id: id,
                quantity: quantity.value,
            })
            .then((response) => {
                events.publish('cart')
            })
    }

    removeItemFromCart(event) {
        event.preventDefault()
        const parent = event.target.parentNode
        const id = event.target.getAttribute('data-id')
        const quantity = parent.querySelector('.product-quantity input').value

        Swal.fire({
            title: 'Are you sure?',
            text: 'Are you sure you want to remove this item from your bag?',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Yes, remove it',
        }).then((result) => {
            if (result.isConfirmed) {
                this.delete(id, quantity)
            }
        })
    }

    delete(id, quantity) {
        axios
            .post('/cart/change.js', {
                id: id,
                quantity: 0,
            })
            .then((response) => {
                events.publish('cart')
            })
            .catch((error) => {
                console.log(error)
            })
    }
}
